import { observer } from 'mobx-react';
import { autoinject, Duration, Enums, formatDuration } from 'Mri.Web.Common';
import * as React from 'react';
import { format } from 'date-fns';
import { LinkContainer } from 'react-router-bootstrap';

export interface IWarrantyAlertLogItemProps {
    readonly da: Mri.DisplayAlerts.DisplayAlertLog;
    readonly rowNumber: number;
}

@autoinject
@observer
export class WarrantyAlertLogItem extends React.Component<IWarrantyAlertLogItemProps> {
    public render() {
        const { da, rowNumber } = this.props;
        return (
            <tr>
                <td>{rowNumber}</td>
                <td>{format(da.logTime, 'Pp')}</td>
                <td>{da.accountName}</td>
                <td>
                    {
                        <LinkContainer to={`/displays/${da.displaySerialNumber}`}>
                            <a className="btn btn-link">{da.displaySerialNumber}</a>
                        </LinkContainer>
                    }
                </td>
                <td>{da.profileName}</td>
                <td>{da.email}</td>
                <td>{da.eventDetails}</td>
                <td>{Enums.toString(Enums.DisplayEventStatus, da.displayEventStatus)}</td>
                <td>{formatDuration(new Duration(da.duration))}</td>
            </tr>
        );
    }
}
